/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Specifies the value type of the claim attribute.
 */
export const ClaimAttributeType = {
    Text: 1,
    Number: 2
} as const;
export type ClaimAttributeType = typeof ClaimAttributeType[keyof typeof ClaimAttributeType];

